import { render } from "./ViewSkillUser.vue?vue&type=template&id=a9f68704&scoped=true"
import script from "./ViewSkillUser.vue?vue&type=script&lang=js"
export * from "./ViewSkillUser.vue?vue&type=script&lang=js"

import "./ViewSkillUser.vue?vue&type=style&index=0&id=a9f68704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f68704"]])

export default __exports__